import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromPunchReducer from '../reducers/punch.reducer';

const selectPunchState = createFeatureSelector<fromPunchReducer.PunchState>(fromPunchReducer.punchFeatureKey);

export const selectPunchesByTurnoverId = createSelector(selectPunchState, state => state.punchesByTurnoverId);
export const selectSelectedPunch = createSelector(selectPunchState, state => state.selectedPunch);
